<template>
    <v-app>
        <v-app-bar
        app
        :color="getThemeColor"
        dark
       
        >
            <div class="d-flex align-center">
                <v-img                
                class="shrink mr-2"
                contain
                src="../../assets/logo.png"
                transition="scale-transition"
                width="40"
                />
                {{ schoolName}}
                
            </div>

            <v-spacer></v-spacer>

            <v-btn
                :color="avatarColor"
                size="36"                
                fab
                dark
                small
                elevation="0"                
            >
            {{getUser}}               
            </v-btn>

            <Logout/>
        </v-app-bar>

        <v-main >
            <form-progress/> 
            <v-container 
                fluid
                class="grey lighten-5"                
            >                                   
                <slot></slot>                
                <v-row
                    align="center"
                    justify="center"
                >
                    <form-navigation/>
                </v-row>
                <v-fab-transition >
                    <v-btn
                        v-show="floatingButton"
                        :key="activeFab.icon"
                        color="primary"
                        fab
                        absolute
                        large
                        dark
                        bottom
                        right
                        @click="quickScroll"
                        class="quick-navigation"
                        style="bottom: 20px"
                    >
                        <v-icon>{{ activeFab.icon }}</v-icon>
                    </v-btn>
                </v-fab-transition>
            </v-container>
            <form-dialog/>                 
        </v-main>
    </v-app> 
    
</template>

<script>
import Logout from '../auth/Logout';
import FormNavigation from '../FormNavigation';
import FormProgress from '../FormProgress';
import FormDialog from '../FormDialog';
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  components: {    
    Logout,
    FormNavigation,
    FormProgress,
    FormDialog,    
  },

  data: () => ({
     documentTop: true,     
     floatingButton: false,     
  }),

  methods: {
      quickScroll(){
          this.documentTop = !this.documentTop;
          if(this.documentTop){
              window.scrollTo(0, document.body.scrollHeight);
          }
      },
      changePassword(){
          this.$router.push('/registration/change-password');
      }

  },

  computed: {
      activeFab () {
          if(this.documentTop){
              return {color: this.primaryColor + ' ' + this.colorDarken, icon: 'mdi-chevron-down'};
          }
          else{
              return {color: this.primaryColor + ' ' + this.colorDarken, icon: 'mdi-chevron-up'}
          }
      },
      getThemeColor(){          
          return this.primaryColor + ' ' + this.colorDarken;
      },
      avatarColor(){
          return this.avatarColor + ' ' + this.avatarDarken;
      },
      ...mapGetters({
          getUser: 'form/getUser',
          schoolName: 'form/getSchoolName',
          primaryColor: 'form/getPrimaryColor',
          colorDarken: 'form/getColorDarken',
          avatarColor: 'form/getAvatarColor',
          avatarDarken: 'form/getAvatarDarken',
      })
      
  }
};
</script>

<style scoped>
    .quick-navigation{
        position: fixed;       
    }
</style>
